import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { widgetDashboard, widgetDashboardEs } from '@lon/shared/assets';
import { isDevEnv, isDevMode } from '@lon/shared/constants';
import { enConfig, esConfig } from '@lon/suit/assets';

export const initTranslationService = () => {
  const storedLanguage = localStorage.getItem('googletrans') || 'en';
  const isDev = isDevMode() || isDevEnv();

  if (isDev) {
    i18next.use(initReactI18next).init({
      lng: storedLanguage,
      fallbackLng: 'en',
      resources: {
        en: { translation: { ...enConfig, ...widgetDashboard } },
        es: { translation: { ...esConfig, ...widgetDashboardEs } },
      },
    });
  } else {
    i18next.use(initReactI18next).init({
      lng: 'en',
      fallbackLng: 'en',
      resources: {
        en: { translation: { ...enConfig, ...widgetDashboard } },
      },
    });
  }
};
